var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "File_management",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "File management",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 29 4 5-13 12-9-7 4-5 5 4z",
    fill: "#c5ebff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25 57h-10v-4.5a16 16 0 1 0 0-31v-18.5h30v13h12v41z",
    fill: "#c5ebff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00ADEF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61 6h-11.87l-3.4-3.68a.99.99 0 0 0 -.73-.32h-30a1 1 0 0 0 -1 1v17.75a17 17 0 0 0 0 32.5v3.75a1 1 0 0 0 1 1h9v3a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1v-54a1 1 0 0 0 -1-1zm-15-.44 8.72 9.44h-8.72zm-42 31.44a15 15 0 1 1 15 15 15.018 15.018 0 0 1 -15-15zm12 19v-2.28a17.432 17.432 0 0 0 3 .28 17 17 0 0 0 0-34 17.432 17.432 0 0 0 -3 .28v-16.28h28v12a1 1 0 0 0 1 1h11v39zm44 4h-34v-2h31a1 1 0 0 0 1-1v-41a.977.977 0 0 0 -.27-.68l-6.75-7.32h9.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 7h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 7h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 12h21v2h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.781 33.375-4-5a1 1 0 0 0 -.726-.375 1.031 1.031 0 0 0 -.762.292l-8.367 8.368-4.3-3.441a1 1 0 0 0 -1.406.156l-4 5a1 1 0 0 0 .167 1.415l9 7a1 1 0 0 0 1.292-.055l13-12a1 1 0 0 0 .102-1.36zm-13.836 11.315-7.531-5.857 2.742-3.427 4.219 3.375a1 1 0 0 0 1.332-.074l8.21-8.21 2.72 3.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.cc89f5312c869b01b1c3fd9816779578.svg";
export { ForwardRef as ReactComponent };